module.exports = __webpack_public_path__ + "media/src/images/landing/rocket-e684524a18ca251e6fa8ed9920c449c6.svg";